import React, { useEffect, useRef, useState } from "react";
import * as modalDataService from './modalDataService';
import * as deviceService from '../deviceService';
import { connect } from "react-redux";
import { debug } from "../../utils";
import { useOutsideClickHandler } from "../../hooks";

const SPACEBAR = ' ';

function TagsField({ tags, selectedTags, disabled }) {

    const [inputValue, setInputValue] = useState('');
    const [showDropdown, setShowDropdown] = useState(false);
    const selectRef = useRef(null);
    const inputRef = useRef(null);

    useOutsideClickHandler(selectRef, () => handleOutsideClick());

    useEffect(() => {
        deviceService.tagList();
    }, [])

    const onInputChange = (value) => {
        setShowDropdown(true)
        if (value.includes(SPACEBAR) && value !== SPACEBAR) {
            if (!selectedTags.find(tag => tag.name === value.trim())) {
                modalDataService.selectTag(value.trim(), selectedTags);
            }
            setInputValue('');
        } else {
            if (value !== SPACEBAR) {
                setInputValue(value);
            }
        }
    }

    const onInputKeyDown = (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        event.preventDefault();
        const tagName = inputValue.trim();
        if (tagName && !selectedTags.find(tag => tag.name === tagName)) {
            modalDataService.selectTag(tagName, selectedTags);
        }
        setInputValue('');
        setShowDropdown(false);
    }

    const onRemoveClick = (index) => {
        modalDataService.unselectTag(index, selectedTags);
        setInputValue('');
    }

    const onSelectAreaClick = () => {
        setShowDropdown(!showDropdown);
        inputRef.current.focus();
    }

    const handleOutsideClick = () => {
        setShowDropdown(false);
        setInputValue('');
    }

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="tags-input">Tags</label>
                <span
                    className={`select2 select2-container select2-container--bootstrap4 modal-v2-tags-select ${disabled ? 'select-disabled' : ''} ${showDropdown ? 'is-open' : ''}`}>
                    <span className="selection" ref={selectRef}>
                        <span className="select2-selection select2-selection--multiple"
                            onClick={disabled ? null : () => onSelectAreaClick()}>
                            <ul className="select2-selection__rendered">

                                {selectedTags.map((tag, index) =>
                                    <li key={index} className="select2-selection__choice">
                                        <span className="select2-selection__choice__remove"
                                            onClick={() => onRemoveClick(index)}>×</span>
                                        {tag.name}
                                    </li>
                                )}

                                <li className="select2-search select2-search--inline">
                                    <input className="select2-search__field" type="search"
                                        id="tags-input"
                                        ref={inputRef}
                                        autoComplete="off" autoCorrect="off"
                                        autoCapitalize="none" spellCheck="false"
                                        disabled={disabled}
                                        placeholder={selectedTags.length ? "" : "Select tag"}
                                        aria-autocomplete="list" value={inputValue}
                                        onKeyDown={onInputKeyDown}
                                        onChange={event => onInputChange(event.target.value)} />
                                </li>

                            </ul>
                        </span>
                        <span className="modal-v2-tags-select-chevron" aria-hidden="true" />
                        {showDropdown && <Dropdown selectedTags={selectedTags}
                            setInputValue={setInputValue}
                            setShowDropdown={setShowDropdown}
                            options={tags.filter(tag => tag.name.toLowerCase().includes(inputValue.toLowerCase()))} />}
                    </span>
                </span>
            </div>
        </div>
    )
}

const Dropdown = ({ options, selectedTags, setInputValue, setShowDropdown }) => {

    const onClick = (tagName, selected) => {
        if (!selected) {
            modalDataService.selectTag(tagName, selectedTags);
            setInputValue('');
            setShowDropdown(false);
        }
    }

    return (
        <span className="select2-dropdown oct_left-zero">
            <span className="select2-results">
                <ul className="select2-results__options">
                    {(options && options.length > 0) ?
                        <>
                            {options.map((option, index) => {
                                if (selectedTags.find(tag => tag.name === option.name)) {
                                    return <li key={index} className="select2-results__option"
                                        onClick={() => onClick(option.name, true)} > {option.name} </li>
                                }
                                return <li key={index} className="select2-results__option"
                                    onClick={() => onClick(option.name, false)}>{option.name}</li>
                            })}
                        </>
                        :
                        <li role="alert" aria-live="assertive"
                            className="select2-results__option select2-results__message">No results found</li>}
                </ul>
            </span>
        </span>
    )
}

function mapStateToProps(state) {
    debug("TagsField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        tags: addDeviceModal.tags || '',
        selectedTags: addDeviceModal.selectedTags || []
    }
}

export default connect(mapStateToProps)(TagsField);
